import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Grid, Header, Icon, Menu, Modal, Pagination, Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import UsersStore from '../../stores/UsersStore'
import LoadingWrapper from '../../components/LoadingWrapper'
import PropTypes from 'prop-types'
import AuthenticationStore from '../../stores/AuthenticationStore'
import Toast from '../../components/Toast'

@inject('authenticationStore')
@observer
class UsersScreen extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore)
  }

  state = {
    showModal: false,
    deleteUser: null,
    canDeleteUser: false
  }

  constructor (props) {
    super(props)
    this.usersStore = new UsersStore()
    window.document.title = 'Liste des utilisateurs'
    this.state.canDeleteUser = this.props.authenticationStore.getRoleForControllerAction('users', 'delete')
  }

  componentDidMount () {
    this.usersStore.loadAll()
  }

  deleteUserConfirmation (deleteUser) {
    this.setState({
      showModal: true,
      deleteUser
    })
  }

  handleDeleteUser = () => {
    const { deleteUser } = this.state
    this.displayModal(false)

    if (deleteUser) {
      this.usersStore.deleteUser(deleteUser.id).then(() => {
        this.usersStore.loadAll()
      }).catch(e => console.error)
      this.setState({ deleteUser: null })
    }
  }

  displayModal (showModal) {
    this.setState({ showModal })
  }

  changePage = (page) => {
    this.usersStore.changePage(page.activePage)
    this.usersStore.loadAll()
  }

  render () {
    const { authenticationStore } = this.props
    const { paging, users, isLoading, toasts } = this.usersStore
    const { showModal, canDeleteUser, deleteUser } = this.state
    return (
      <>
        <Header as='h2'>Liste des utilisateurs</Header>
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Toast toasts={toasts} />
        <Modal open={showModal} onClose={() => this.displayModal(false)}>
          <Modal.Header>Supprimer l'utilisateur</Modal.Header>
          <Modal.Content>Êtes-vous sûr de vouloir supprimer l'utilisateur {deleteUser && deleteUser.fullName}?</Modal.Content>
          <Modal.Actions>
            <Button content='Annuler' onClick={() => this.displayModal(false)} />
            <Button color='google plus' content='Supprimer' onClick={this.handleDeleteUser} />
          </Modal.Actions>
        </Modal>
        <Menu secondary>
          <Menu.Item>
            <Button primary icon as={Link} to='/users/create'><Icon name='plus' />Ajouter un utilisteur</Button>
          </Menu.Item>
        </Menu>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              {paging.Users &&
                <Pagination
                  onPageChange={(e, data) => this.changePage(data)}
                  totalPages={paging.Users.pageCount}
                  activePage={paging.Users.page}
                />}
              {!!users.length &&
                <Table celled>
                  <Table.Header key='header'>
                    <Table.Row>
                      <Table.HeaderCell>Code</Table.HeaderCell>
                      <Table.HeaderCell>Prénom</Table.HeaderCell>
                      <Table.HeaderCell>Nom</Table.HeaderCell>
                      <Table.HeaderCell>Courriel</Table.HeaderCell>
                      <Table.HeaderCell>Rôle</Table.HeaderCell>
                      <Table.HeaderCell>Status</Table.HeaderCell>
                      <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body key='body'>
                    {users.map(user => {
                      return (
                        <Table.Row key={`user_${user.id}`}>
                          <Table.Cell>
                            {user.code}
                          </Table.Cell>
                          <Table.Cell>
                            {user.first_name}
                          </Table.Cell>
                          <Table.Cell>
                            {user.last_name}
                          </Table.Cell>
                          <Table.Cell>
                            {user.email}
                          </Table.Cell>
                          <Table.Cell>
                            {user.role.name}
                          </Table.Cell>
                          <Table.Cell>
                            {user.status}
                          </Table.Cell>
                          <Table.Cell>
                            <Link to={`/users/edit/${user.id}`}><Icon link name='pencil' /></Link>
                            {canDeleteUser &&
                            authenticationStore.loggedUser.id !== user.id && user.status !== 'DELETED' &&
                              <Icon color='red' link name='trash' onClick={() => { this.deleteUserConfirmation(user) }} />}
                          </Table.Cell>
                        </Table.Row>
                      )
                    })}
                  </Table.Body>
                </Table>}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}

export default UsersScreen
